import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // load translations using http (default public/locales/{{lng}}/{{ns}}.json)
  .use(Backend)
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  .init({
    // Add the supported languages. This helps i18next handle fallbacks and loading correctly.
    supportedLngs: ['en-GB', 'fr', 'es', 'de'],
    
    backend: {
      loadPath: 'https://theone.procleaneruk.co.uk/locales/{{lng}}/translation.json',
    },
    
    fallbackLng: 'en-GB', // Fallback language if detected language is not available
    debug: false, // Set to true in development for console logs

    // Default namespace
    ns: ['translation'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false, // React already prevents XSS
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'], // Cache detected language
    }
  });

export default i18n;

